import Vue from 'vue'
import Notifications from 'vue-notification'

import './assets/css/style.scss'
import './icons.js'

Vue.config.productionTip = false

Vue.use(Notifications)
